<template>
  <div class="product-screen height-802">
    <!-- 分类 -->
    <div>
      <div class="title font-sc-me">请选择油品类型</div>
      <div class="info height-568">
        <div
          class="item item1"
          :class="type_name === item ? 'ac-item font-sc-me' : 'bg-f6'"
          v-for="(item, index) in oils_type_list"
          :key="index"
          @click="searchOilsList(item)"
        >
          {{ item }}
          <div class="check-sign flex" v-if="type_name === item">
            <img src="../../../assets/check_sign.png" alt="" />
          </div>
        </div>
      </div>
    </div>

    <!-- 产品 -->
    <div v-if="list.length">
      <div class="title font-sc-me blue">请选择壳牌产品</div>
      <div class="info height-568">
        <div
          class="item item2"
          :class="sel_name === item ? 'ac-item font-sc-me' : 'bg-f6'"
          v-for="(item, index) in list"
          :key="index"
          @click="search(item)"
        >
          {{ item }}
          <div class="check-sign flex" v-if="sel_name === item">
            <img src="../../../assets/check_sign.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { onMounted, ref, reactive, toRefs, getCurrentInstance } from "vue";
import { useRouter } from "vue-router";
import Api from "../../../api/ProductApi";
export default {
  name: "ProductScreen",
  props: {
    search_type: {
      type: Number,
      required: true
    }
  },
  setup(props, proxy1) {
    const { proxy } = getCurrentInstance();
    const router = useRouter();
    let search_type = ref(0);
    let list = ref([]);
    let oils_type_list = ref([]);
    let datas = reactive({
      sel_name: "", // 选中壳牌产品名称
      type_name: "" // 选中的油品类型名称
    });

    // 获取产品类型
    const fetchProductType = async () => {
      proxy.$toast.loading({
        message: "加载中..."
      });
      try {
        const { data } = await Api.getOilsTypeListApi({
          type: search_type.value
        });
        console.log("data", data);
        proxy.$toast.clear();
        oils_type_list.value = data;
      } catch (error) {
        proxy.$toast.clear();
        console.error(error);
      }
    };

    // 获取
    const getList = async () => {
      proxy.$toast.loading({
        message: "加载中..."
      });
      try {
        const { data } = await Api.oilsScreenList({
          type: search_type.value,
          oils_type: datas.type_name
        });
        proxy.$toast.clear();
        list.value = data;
      } catch (error) {
        proxy.$toast.clear();
        console.error(error);
      }
    };

    // 选中油品类型
    const searchOilsList = val => {
      datas.type_name = val;
      getList();
    };

    // 跳转结果页
    const search = val => {
      datas.sel_name = val;
      proxy1.emit("close"); // 关闭父组件的弹框
      router.push({
        name: "List",
        query: {
          search_type: 2,
          keywords: val
        }
      });
    };

    onMounted(() => {
      search_type.value = props.search_type;
      fetchProductType();
    });

    return {
      ...toRefs(datas),
      list,
      oils_type_list,
      searchOilsList,
      search
    };
  }
};
</script>
<style lang="sass" scoped>
@import "~@/styles/mixins/vw"
.product-screen
  width: 100%
  height: vw(706)
  padding-bottom: vw(60)
  font-size: vw(28)
  color: #404040
  background: #FFFFFF
  .title
    padding: vw(40) 0 vw(20) vw(40)
    font-size: vw(32)
  .blue
    color: #5E7BFF
  .info
    display: flex
    padding: vw(0) vw(40) 0 vw(20)

    flex-wrap: wrap
    .item
      position: relative
      width: vw(320)
      height: vw(70)
      margin: vw(20) 0 0 vw(20)
      padding: 0 vw(10)
      text-align: center
      .check-sign
        position: absolute
        right: vw(0)
        bottom: 0
        width: vw(32)
        height: vw(32)
    .item1
      line-height: vw(70)
    .item2
      height: vw(96)
      display: flex
      text-align: center
      justify-content: center
      align-items: center
    .bg-f6
      color: #404040
      background: #F6F6F6
    .ac-item
      color: #5E7BFF
      border: vw(1) solid #5E7BFF
      background: #EEF1FF
      box-shadow: 0 vw(12) vw(24) 0 rgba(94, 123, 255, 0.15)
  .btn
    display: flex
    width: vw(450)
    height: vw(84)
    margin: vw(40) auto 0
    font-size: vw(24)
    color: #999999
    border-radius: vw(42)
    background: #F7F7F7

    justify-content: center

    align-items: center
    .arrow-right
      width: vw(14)
      height: vw(20)
      margin-left: vw(12)
    .arrow-top
      width: vw(20)
      height: vw(14)
      margin-left: vw(14)
.height-802
  height: 96vh
.height-452
  overflow-y: hidden
  max-height: vw(452)
.height-568
  overflow-y: auto
  max-height: vw(650)
</style>
